// @flow
import React from "react"
import featureFlags from "global/feature-flags"
import { Text } from "componentsStyled/Typography/Texts"
import { formatMoney } from "data/units/money/formatters"
import { Spread } from "componentsStyled/Layout/Flex"
import { discountTypes } from "data/reservations/constants"
import type { Discount } from "data/reservations/types"
import { calculateDiscount } from "../helpers"

type Props = {
  totalPrice: number,
  fullPrice: number,
  prices: number[],
  discounts: Discount[],
  currency: string,
}

const ReservationPaymentSummary = ({
  totalPrice,
  fullPrice,
  prices,
  discounts,
  currency,
}: Props) => {
  const upsellSubscription = featureFlags.showSubscriptionUpsellInProductsPage()

  const hasSubscriptionDiscount = Boolean(discounts && discounts.find(discount => discount.type === discountTypes.subscription))

  return (
    <React.Fragment>
      <Text uppercase bold black>
        Payment Summary
      </Text>
      <Spread>
        <Text>
          Subtotal
        </Text>
        <Text>
          {formatMoney(fullPrice, true, currency)} {currency}
        </Text>
      </Spread>
      {discounts.length > 0
        ? discounts.map((discount, i) => {
          if (discount.limitDays && discount.limitDays < 0) { return "" }

          const subscriptionTypeDisplay = discount.type.charAt(0).toUpperCase() + discount.type.slice(1)

          return (
            <Spread key={i}>
              <Text>
                {subscriptionTypeDisplay} discount
              </Text>
              <Text>
                -
                {formatMoney(calculateDiscount(prices, discount, 0), true, currency)} {currency}
              </Text>
            </Spread>
          )
        })
        : ""
      }
      {!hasSubscriptionDiscount
        ? <Spread>
            <Text>
              {upsellSubscription ? "Subscription discount" : "Discount"}
            </Text>
            <Text>
              -
              {formatMoney(0, true, currency)} {currency}
            </Text>
          </Spread>
        : ""
      }
      <br/>
      <Spread>
        <Text uppercase bold black>
          Your Total
        </Text>
        <Text uppercase bold black>
          {formatMoney(totalPrice, true, currency)} {currency}
        </Text>
      </Spread>
    </React.Fragment>
  )
}

export default ReservationPaymentSummary



// WEBPACK FOOTER //
// ./src/components/ReservationPricing/ReservationPaymentSummary/index.js